// extracted by mini-css-extract-plugin
export var icon = "_4p-1";
export var subtext = "_4p-0";